import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toArray from "@babel/runtime/helpers/toArray";
var _TYPE_TO_VALUE_GETTER;
import { compose } from 'recompose';

// Lodash
import _property from 'lodash/property';
import _isFunction from 'lodash/isFunction';
import _get from 'lodash/get';
import _head from 'lodash/head';

// Constants
import { getMomentValueOf } from '@tekion/tekion-base/utils/dateUtils';
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import WORKSPACE_FILTER_TYPES from '../../../../constants/filterSection.workspaceFilterTypes';
import FILTER_TYPES from '../../../../constants/filterSection.filterTypes';
import { IN, EQUALS } from '../../../../constants/filterSection.operators';

// Readers
import filterTypeReader from '../../../../readers/FilterType';

// Helpers
import getOperatorForFilterType from '../../../../factory/filterDialog.operator';

// IN is the operator for default filter
var getSelectFilterValue = function getSelectFilterValue(filterType) {
  var filterId = filterTypeReader.id(filterType);
  for (var _len = arguments.length, valueParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    valueParams[_key - 1] = arguments[_key];
  }
  var filterValues = _get(valueParams, '0.value');
  return {
    type: filterId,
    operator: IN.id,
    values: filterValues,
    additional: _get(valueParams, '0')
  };
};
var getOperatorIdForFilterType = compose(_property('id'), _head, getOperatorForFilterType);
var getDateRangeValues = function getDateRangeValues(filterType) {
  for (var _len2 = arguments.length, valueParams = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    valueParams[_key2 - 1] = arguments[_key2];
  }
  var _head2 = _head(valueParams),
    _head3 = _toArray(_head2),
    startDate = _head3[0],
    endDate = _head3[1],
    additional = _head3.slice(2);
  var filterId = filterTypeReader.id(filterType);
  var dateRangeOperatorId = getOperatorIdForFilterType(filterType);
  var filterValues = startDate && endDate ? [getMomentValueOf(startDate), getMomentValueOf(endDate)] : EMPTY_ARRAY;
  return {
    type: filterId,
    operator: dateRangeOperatorId,
    values: filterValues,
    additional: additional
  };
};
var getSingleDateValue = function getSingleDateValue(filterType) {
  for (var _len3 = arguments.length, valueParams = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    valueParams[_key3 - 1] = arguments[_key3];
  }
  var date = _head(valueParams);
  var filterId = filterTypeReader.id(filterType);
  var filterValues = [getMomentValueOf(date)];
  return {
    type: filterId,
    operator: EQUALS.id,
    values: filterValues
  };
};
var getMonthValue = function getMonthValue(filterType, valueParam) {
  var filterId = filterTypeReader.id(filterType);
  return {
    type: filterId,
    operator: getOperatorIdForFilterType(filterType),
    values: valueParam
  };
};
var getCustomFilterValue = function getCustomFilterValue(filterType) {
  var additional = filterTypeReader.additional(filterType);
  var _ref = additional || EMPTY_OBJECT,
    getValueFunc = _ref.getValueFunc;
  if (!getValueFunc) return null;
  for (var _len4 = arguments.length, valueParams = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    valueParams[_key4 - 1] = arguments[_key4];
  }
  return getValueFunc(filterType, valueParams);
};
var TYPE_TO_VALUE_GETTER = (_TYPE_TO_VALUE_GETTER = {}, _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.SINGLE_SELECT, getSelectFilterValue), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.MULTI_SELECT, getSelectFilterValue), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.ASYNC_SINGLE_SELECT, getSelectFilterValue), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.ASYNC_MULTI_SELECT, getSelectFilterValue), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.DATE, getDateRangeValues), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.DATE_WITHOUT_PRESET, getDateRangeValues), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.DATE_TIME_WITHOUT_PRESET, getDateRangeValues), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.DATE_PICKER, getSingleDateValue), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.MONTH_PICKER, getMonthValue), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.VIRTUALIZED_MULTI_SELECT, getSelectFilterValue), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.VIRTUALIZED_SELECT, getSelectFilterValue), _defineProperty(_TYPE_TO_VALUE_GETTER, FILTER_TYPES.CUSTOM, getCustomFilterValue), _defineProperty(_TYPE_TO_VALUE_GETTER, WORKSPACE_FILTER_TYPES.WORKSPACE_ASYNC_MULTI_SELECT, getSelectFilterValue), _TYPE_TO_VALUE_GETTER);
var getFilterValueOnChange = function getFilterValueOnChange(filterType) {
  var typeOfFilter = filterTypeReader.type(filterType);
  var valueGetter = TYPE_TO_VALUE_GETTER[typeOfFilter];
  if (!_isFunction(valueGetter)) return null;
  for (var _len5 = arguments.length, valueParams = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    valueParams[_key5 - 1] = arguments[_key5];
  }
  return valueGetter.apply(void 0, [filterType].concat(valueParams));
};
export default getFilterValueOnChange;